module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I had the privilege over twenty-five years ago of meeting, and becoming friends with, one of this country’s unknown aviation authors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roy Brooks would always have time (and patience) with me in my endeavours to learn about the history of aviation in Sussex.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first part of this story of Sussex aviation was researched and written by Roy at a time when the internet had not been born. Thus, this story was conceived and executed by hand. His tenacity and determination with local libraries and historical sources was a remarkable and unmatched feat, to his external credit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why it was never published in anything other than microfiche form I’m not sure, but it is possible that Roy did not have access to supporting material such as postcards and pictures etc. This story has now been enhanced to show the history of aviation in Sussex.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My wish that this book will stand as a tribute to Roy and all his hard work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wish to thank Roy’s widow Betty and her family for allowing me to have this published and never losing faith.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Josh Spoor,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Southwick, 2020")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e812272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Foreword.vue
// module id = 72
// module chunks = 0